<template>
  <div class="real-name-verification">
    <!-- 头部区域 -->
    <div class="header">
      <div class="header-left">
        <button class="back-btn" @click="goBack">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
        <div class="title">实名认证</div>
      </div>
    </div>

    <!-- 表单区域 -->
    <div class="form-container">
      <el-form :model="formData" :rules="formRules" ref="verificationForm" label-width="70px"
        style="height: calc(100vh - 144px);overflow-y: auto;">
        <div>
          <!-- 实名信息 -->
          <div class="form-section">
            <div class="section-title">实名信息</div>
            <el-form-item label="姓名" prop="name">
              <el-input type="text" v-model="formData.name" :disabled="verified" placeholder="请输入姓名" clearable />
            </el-form-item>
            <el-form-item label="身份证" prop="idNumber">
              <el-input type="text" v-model="formData.idNumber" :disabled="verified" placeholder="请输入身份证号码" clearable />
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input type="text" v-model="formData.phone" placeholder="请输入手机号" clearable />
            </el-form-item>
            <el-form-item label="微信号" prop="wechatAccount">
              <el-input type="text" v-model="formData.wechatAccount" placeholder="请输入微信账号" clearable />
            </el-form-item>
            <el-form-item label="闲鱼号" prop="xyNumber">
              <el-input type="textarea" v-model="formData.xyNumber" placeholder="请输入闲鱼号(多个使用逗号分隔)" clearable />
            </el-form-item>
            <el-form-item label="抖音号" prop="dyNumber">
              <el-input type="textarea" v-model="formData.dyNumber" placeholder="请输入抖音号(多个使用逗号分隔)" clearable />
            </el-form-item>
            <el-form-item label="小红书" prop="xhNumber">
              <el-input type="textarea" v-model="formData.xhNumber" placeholder="请输入小红书号(多个使用逗号分隔)" clearable
                :row="1" />
            </el-form-item>
            <el-form-item label="视频号" prop="spNumber">
              <el-input type="textarea" v-model="formData.spNumber" placeholder="请输入视频号(多个使用逗号分隔)" clearable />
            </el-form-item>
          </div>

          <!-- 银行卡信息 -->
          <div class="form-section">
            <div class="section-title">银行卡</div>
            <el-form-item label="银行卡号" prop="bankCard">
              <el-input type="text" v-model="formData.bankCard" placeholder="请输入实名一致的银行卡号" clearable />
            </el-form-item>
            <el-form-item label="开户银行" prop="bankName">
              <el-input type="text" v-model="formData.bankName" placeholder="请输入开户银行（如：中国建设银行）" clearable />
            </el-form-item>
          </div>

          <!-- 支付宝信息 -->
          <!-- <div class="form-section">
            <div style="border-bottom: 2px solid #42b983;margin-bottom: 10px;"></div>
            <el-form-item label="支付宝" prop="alipayAccount">
              <el-input type="text" v-model="formData.alipayAccount" placeholder="请输入支付宝账号" clearable />
            </el-form-item>
            <el-form-item label="预留手机号" prop="alipayPhone">
              <el-input type="text" v-model="formData.alipayPhone" placeholder="请输入支付宝预留手机号" clearable />
            </el-form-item>
          </div> -->

          <!-- 微信信息 -->
          <!-- <div class="form-section">
            <div style="border-bottom: 2px solid #42b983;margin-bottom: 10px;"></div>
            <el-form-item label="预留手机号" prop="wechatPhone">
              <el-input type="text" v-model="formData.wechatPhone" placeholder="请输入微信预留手机号" clearable />
            </el-form-item>
          </div> -->
        </div>

        <div>
          <!-- 提示信息 -->
          <div class="notice">
            <span class="asterisk">*</span>
            成功通过实名认证，不允许更换实名人姓名和身份证信息，其他信息可以修改！
          </div>

          <!-- 协议同意 -->
          <div class="agreement">
            <label class="checkbox-label">
              <input type="checkbox" v-model="agreedToTerms" class="checkbox" />
              <span class="checkmark"></span>
              <span class="agreement-text">
                我已阅读并同意签署
                <!-- <a href="#" class="link">《灵活就业合作伙伴协议》</a>
            <a href="#" class="link">《用户服务协议》</a>
            及 -->
                <a href="#" class="link">《隐私政策》</a>
              </span>
            </label>
          </div>

        </div>
      </el-form>
      <!-- 提交按钮 -->
      <el-button type="primary" :disabled="!canSubmit || submitting" @click="handleSubmit" :loading="submitting">
        {{ submitting ? '提交中...' : '提交' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { getCurrentUser, submitRealName, getRealNameStatus, updateContactInfo } from '@/utils/jdApi'

export default {
  name: 'RealNameVerification',
  data() {
    return {
      userId: 'T3EFF8C57A8',
      formData: {
        name: '',
        idNumber: '',
        bankCard: '',
        phone: '',
        xyNumber: '',
        dyNumber: '',
        xhNumber: '',
        spNumber: '',
        bankName: '',
        // 支付宝相关字段
        alipayAccount: '',
        alipayPhone: '',
        // 微信相关字段
        wechatAccount: '',
        wechatPhone: ''
      },
      formRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { max: 50, message: '姓名长度不能超过50个字符', trigger: 'blur' }
        ],
        xyNumber: [
          { required: true, message: '请输入闲鱼号', trigger: 'blur' },
        ],
        dyNumber: [
          { required: true, message: '请输入抖音号', trigger: 'blur' },
        ],
        wechatAccount: [
          { required: true, message: '请输入微信号', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        idNumber: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' },
          { pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, message: '身份证号码格式不正确', trigger: 'blur' }
        ],
        bankCard: [
          { pattern: /^\d{16,19}$/, message: '银行卡号格式不正确', trigger: 'blur' }
        ],
        alipayPhone: [
          { pattern: /^1[3-9]\d{9}$/, message: '支付宝手机号格式不正确', trigger: 'blur' }
        ],
        wechatPhone: [
          { pattern: /^1[3-9]\d{9}$/, message: '微信手机号格式不正确', trigger: 'blur' }
        ]
      },
      agreedToTerms: false,
      submitting: false,
      verified: false
    }
  },
  computed: {
    canSubmit() {
      const basicInfo = this.formData.name && this.formData.idNumber && this.formData.phone && this.agreedToTerms
      // 检查是否至少填写了一个账户类型
      const hasBankInfo = this.formData.bankCard && this.formData.bankName
      const hasAlipayInfo = this.formData.alipayAccount
      const hasWechatInfo = this.formData.wechatAccount

      const hasAtLeastOneAccount = hasBankInfo || hasAlipayInfo || hasWechatInfo

      return basicInfo && hasAtLeastOneAccount
    }
  },
  mounted() {
    const currentUser = getCurrentUser()
    if (currentUser) {
      this.userId = currentUser.username || 'T3EFF8C57A8'
    }
    this.loadRealName()
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.go(-1)
    },
    async loadRealName() {
      try {
        const res = await getRealNameStatus()
        if (res && res.success && res.data) {
          const d = res.data
          // 回显
          this.formData.name = d.realName || ''
          this.formData.idNumber = d.idCard || ''
          this.formData.bankCard = d.bankAccount || ''
          this.formData.phone = d.phone || ''
          this.formData.bankName = d.bankName || ''
          this.formData.alipayAccount = d.alipayAccount || ''
          this.formData.alipayPhone = d.alipayPhone || ''
          this.formData.wechatAccount = d.wechatAccount || ''
          this.formData.wechatPhone = d.wechatPhone || ''
          // 社交账号回显
          this.formData.xyNumber = d.xyNumber || ''
          this.formData.dyNumber = d.dyNumber || ''
          this.formData.xhNumber = d.xhNumber || ''
          this.formData.spNumber = d.spNumber || ''
          // 已认证则禁用实名信息编辑
          this.verified = d.verificationStatus === 'VERIFIED'
        }
      } catch (e) {
        // 忽略加载错误，仅不回显
      }
    },
    async handleSubmit() {
      // 使用el-form的验证
      try {
        await this.$refs.verificationForm.validate()
      } catch (error) {
        this.showMessage('请检查表单填写是否正确', 'warning')
        return
      }

      if (!this.canSubmit) {
        this.showMessage('请至少填写一个账户类型信息并同意协议', 'warning')
        return
      }

      this.submitting = true
      // 构建提交数据，包含所有字段
      const submitData = {
        realName: this.formData.name,
        idCard: this.formData.idNumber,
        // 银行卡信息
        bankAccount: this.formData.bankCard ? this.formData.bankCard.replace(/\s/g, '') : '',
        bankName: this.formData.bankName || '',
        phone: this.formData.phone || '',
        // 社交账号
        xyNumber: this.formData.xyNumber || '',
        dyNumber: this.formData.dyNumber || '',
        xhNumber: this.formData.xhNumber || '',
        spNumber: this.formData.spNumber || '',
        // 支付宝信息
        alipayAccount: this.formData.alipayAccount || '',
        alipayPhone: this.formData.alipayPhone || '',
        // 微信信息
        wechatAccount: this.formData.wechatAccount || '',
        wechatPhone: this.formData.wechatPhone || ''
      }

      if (this.verified) {
        // 已实名：仅更新联系信息
        updateContactInfo(submitData).then(res => {
          if (res && res.success) {
            this.showMessage('实名认证信息提交成功，请等待审核', 'success')
            // 成功后刷新状态
            this.loadRealName()
          } else {
            this.showMessage('提交失败', 'error')
          }
        }).finally(() => {
          this.submitting = false
        })
      } else {
        // 首次提交：提交实名
        submitRealName(submitData).then(res => {
          if (res && res.success) {
            this.showMessage('实名认证信息提交成功，请等待审核', 'success')
            // 成功后刷新状态
            this.loadRealName()
          } else {
            this.showMessage('提交失败', 'error')
          }
        }).finally(() => {
          this.submitting = false
        })
      }


    },

    validateIdNumber(idNumber) {
      // 简单的身份证号码验证
      const idRegex = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      return idRegex.test(idNumber)
    },

    validateBankCard(bankCard) {
      // 简单的银行卡号验证（16-19位数字）
      const cardRegex = /^\d{16,19}$/
      return cardRegex.test(bankCard.replace(/\s/g, ''))
    },

    validatePhone(phone) {
      // 手机号验证
      const phoneRegex = /^1[3-9]\d{9}$/
      return phoneRegex.test(phone)
    },

    showMessage(message, type = 'info') {
      const messageEl = document.createElement('div')
      messageEl.className = `message-toast message-${type}`
      messageEl.textContent = message

      Object.assign(messageEl.style, {
        position: 'fixed',
        top: '20px',
        left: '50%',
        padding: '12px 24px',
        borderRadius: '6px',
        color: 'white',
        fontSize: '14px',
        zIndex: '9999',
        transition: 'all 0.3s ease',
        opacity: '0',
        transform: 'translateX(-50%) translateY(-20px)'
      })

      const colors = {
        success: '#42b983',
        error: '#f56c6c',
        warning: '#e6a23c',
        info: '#409eff'
      }
      messageEl.style.backgroundColor = colors[type] || colors.info

      document.body.appendChild(messageEl)

      setTimeout(() => {
        messageEl.style.opacity = '1'
        messageEl.style.transform = 'translateX(-50%) translateY(0)'
      }, 10)

      setTimeout(() => {
        messageEl.style.opacity = '0'
        messageEl.style.transform = 'translateX(-50%) translateY(-20px)'
        setTimeout(() => {
          if (messageEl.parentNode) {
            messageEl.parentNode.removeChild(messageEl)
          }
        }, 300)
      }, 3000)
    }
  }
}
</script>

<style scoped lang="scss">
.real-name-verification {
  margin: 0 auto;
  padding: 10px;
  background: #f5f5f5;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.header {
  background: linear-gradient(135deg, #42b983, #369870);
  padding: 4px;
  border-radius: 12px;
  margin-bottom: 10px;
  color: white;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.back-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  color: white;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.back-btn svg {
  width: 20px;
  height: 20px;
}

.title {
  font-size: 18px;
  font-weight: 600;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.avatar {
  position: relative;
}

.avatar-icon {
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
}

.user-id {
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 1px;
}

.form-container {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}

.form-section {
  margin-bottom: 10px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  padding-bottom: 10px;
  border-bottom: 2px solid #42b983;
  margin-bottom: 10px;
}

.form-group {
  margin-bottom: 10px;
}

.form-group label {
  display: block;
  font-size: 14px;
  color: #666;
  margin-bottom: 8px;
  font-weight: 500;
}

.input-field {
  width: 100%;
  box-sizing: border-box;
}

.notice {
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 4px;
  margin-bottom: 10px;
  font-size: 12px;
  color: #856404;
  line-height: 1.5;
}

.asterisk {
  color: #f56c6c;
  font-weight: bold;
  margin-right: 4px;
}

.agreement {
  margin-bottom: 10px;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  line-height: 1.5;
}

.checkbox {
  display: none;
}

.checkmark {
  width: 10px;
  height: 10px;
  border: 2px solid #42b983;
  border-radius: 3px;
  margin-right: 8px;
  margin-top: 2px;
  flex-shrink: 0;
  position: relative;
  transition: all 0.3s ease;
}

.checkbox:checked+.checkmark {
  background: #42b983;
}

.checkbox:checked+.checkmark::after {
  content: '✓';
  position: absolute;
  top: -2px;
  left: 2px;
  color: white;
  font-size: 12px;
  font-weight: bold;
}

.agreement-text {
  flex: 1;
  color: #666;
}

.link {
  color: #42b983;
  text-decoration: none;
  font-weight: 500;
}

.link:hover {
  text-decoration: underline;
}

.submit-btn {
  width: 100%;
  background: #42b983;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.submit-btn:hover:not(:disabled) {
  background: #369870;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(66, 185, 131, 0.3);
}

.submit-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .real-name-verification {
    padding: 10px;
  }

  .header {
    padding: 4px;
  }

  .form-container {
    padding: 10px;
    flex: 1;
  }

  .user-info {
    gap: 10px;
  }

  .avatar-icon {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }

  .user-id {
    font-size: 14px;
  }
}

::v-deep {
  .el-form-item {
    margin-bottom: 10px;
  }

  .el-form-item__label {
    line-height: 32px !important;
  }

  .el-form-item__content {
    line-height: 32px !important;
  }

  .checkbox:checked+.checkmark[data-v-cc15a584]::after {
    top: -4px;
    left: 1px;
  }

  .el-textarea__inner {
    line-height: 1;
  }
}
</style>
